import React, { useEffect, useState } from "react";
import CASCementLoading from "./CASCementLoading";
import CASLoadingReport from "./CASCementLoading";
import axios from "axios";
import {
  BiSolidSkipNextCircle,
  BiSolidSkipPreviousCircle,
} from "react-icons/bi";
import {
  changeDateByDays,
  getCurrentDate,
  getCurrentMonthFirstDate,
} from "../../Utilitie";
import Loading from "../../Extra/Loading";
import AdvLoading from "./AdvLoading";
import ActualLoadingSummary from "./ActualLoadingSummary";
const urlPrefix = process.env.REACT_APP_URL_PREFIX;

const CASLoading = () => {
  const [activePage, setActivePage] = useState("Cement");
  const [loading, setLoading] = useState(false);

  const [error, setError] = useState(null);
  const [fromDate, setFromDate] = useState(getCurrentDate());
  const [toDate, setToDate] = useState(getCurrentDate());
  const [fetchedData, setFetchedData] = useState(null);

  const pages = ["Cement", "Other"];

  const handleBtnClick = (btnName) => {
    setActivePage(btnName);
  };
  const handleDayChange = (days) => {
    const newDate = changeDateByDays(fromDate, days);
    setFromDate(newDate);
  };
  const fetchData = async () => {
    setError(null);
    setLoading(true);
    try {
      const response = await axios.get(
        `${urlPrefix}LoadingExpDateReportOnlyDate?only_date=${fromDate}`,
      );
      setFetchedData(response.data.data);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
      setError(error);
    }
  };
  useEffect(() => {
    fetchData();
  }, [fromDate]);
  const a = [
    { name: "ram", age: 78, city: "jbp" },
    { name: "mohan", age: 83, city: "bpl" },
  ];
  return (
    <div>
      {/* <div className="newUiBody">
        {pages.map((button, index) => {
          return (
            <button
              key={index}
              className={`btn btn-outline-dark m-1 ${
                activePage === button && "active"
              }`}
              onClick={() => {
                handleBtnClick(button);
              }}
            >
              {button}
            </button>
          );
        })}
      </div> */}
      <div className=" d-flex justify-content-between align-items-center newUiBody bg-dark text-white">
        <h5> Divisional Loading report </h5>
        <div className="row">
          <button
            className="btn btn-sm btn-outline-light col-md me-1 p-1"
            onClick={() => {
              handleDayChange(-1);
            }}
          >
            <BiSolidSkipPreviousCircle
              style={{ fontSize: "30px" }}
              className="p-0 m-0"
            />
          </button>
          <input
            type="date"
            className="form-control col-md me-1"
            max={getCurrentDate()}
            value={fromDate}
            onChange={(e) => {
              setFromDate(e.target.value);
            }}
          />
          <button
            className={`btn btn-outline-light col-md me-1 p-1 ${fromDate >= getCurrentDate() && "disabled"}`}
            onClick={() => {
              handleDayChange(+1);
            }}
          >
            <BiSolidSkipNextCircle
              style={{ fontSize: "30px" }}
              className="p-0 m-0"
            />
          </button>
          {/* <input
            type="date"
            className="form-control me-1 col-md"
            max={getCurrentDate()}
            value={toDate}
            onChange={(e) => {
              setToDate(e.target.value);
            }}
          /> */}
        </div>
      </div>
      <div>
        {loading && <Loading />}
        {error && (
          <div className="alert alert-danger m-0 p-2">
            <strong>Relational Mapping Error:</strong> ({error.message})
          </div>
        )}
      </div>
      <div>
        {fetchedData && (
          <CASLoadingReport
            activePage={"CEMT"}
            data={fetchedData?.filter((f) => f.commodity === "CEMT")}
            date={{ from: fromDate, to: toDate }}
          />
        )}
      </div>
      <div>
        {fetchedData && (
          <CASLoadingReport
            activePage={"OTHER"}
            data={fetchedData?.filter((f) => f.commodity !== "CEMT")}
            date={{ from: fromDate, to: toDate }}
          />
        )}
        {fetchedData && (
          <ActualLoadingSummary
            data={fetchedData}
            date={{ from: fromDate, to: toDate }}
          />
        )}
        {fromDate === getCurrentDate() && fetchedData && (
          <AdvLoading
            activePage={"ADV"}
            data={fetchedData}
            date={{ from: fromDate, to: toDate }}
          />
        )}
      </div>
    </div>
  );
};

export default CASLoading;
